import React from 'react';
import { Quote } from 'lucide-react';
export const Testimonials = () => {
  return <section id="testimonials" className="w-full py-16 bg-white" data-id="element-258">
      <div className="container mx-auto px-4 md:px-8" data-id="element-259">
        <h2 className="text-3xl md:text-4xl font-bold mb-2 text-center text-gray-900" data-id="element-260">
          Others Are Seeing the Same Results
        </h2>
        <p className="text-center text-xl mb-12 text-gray-600" data-id="element-261">
          <span className="font-bold" data-id="element-262">Real people. Real results.</span>
        </p>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-263">
          <div className="bg-gray-50 p-8 rounded-lg shadow-md" data-id="element-264">
            <div className="flex justify-center mb-4" data-id="element-265">
              <div className="bg-gray-200 p-2 rounded-full" data-id="element-266">
                <Quote className="w-8 h-8 text-gray-700" data-id="element-267" />
              </div>
            </div>
            <p className="text-xl mb-4 text-center italic text-gray-800" data-id="element-268">
              "I <span className="font-bold" data-id="element-269">dreaded bedtime</span> for so long.
              Now I actually{' '}
              <span className="font-bold" data-id="element-270">look forward to sleep</span> again."
            </p>
            <p className="text-center font-semibold text-xl text-gray-900" data-id="element-271">
              Maggie, 74
            </p>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg shadow-md" data-id="element-272">
            <div className="flex justify-center mb-4" data-id="element-273">
              <div className="bg-gray-200 p-2 rounded-full" data-id="element-274">
                <Quote className="w-8 h-8 text-gray-700" data-id="element-275" />
              </div>
            </div>
            <p className="text-xl mb-4 text-center italic text-gray-800" data-id="element-276">
              "For the <span className="font-bold" data-id="element-277">first time in years</span>, I
              slept through the night.{' '}
              <span className="font-bold" data-id="element-278">No stabbing pain</span> at 2 AM."
            </p>
            <p className="text-center font-semibold text-xl text-gray-900" data-id="element-279">
              Colin, 68
            </p>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg shadow-md" data-id="element-280">
            <div className="flex justify-center mb-4" data-id="element-281">
              <div className="bg-gray-200 p-2 rounded-full" data-id="element-282">
                <Quote className="w-8 h-8 text-gray-700" data-id="element-283" />
              </div>
            </div>
            <p className="text-xl mb-4 text-center italic text-gray-800" data-id="element-284">
              "I wear mine every evening while watching telly — my knees feel
              <span className="font-bold" data-id="element-285"> calmer</span>, and I'm{' '}
              <span className="font-bold" data-id="element-286">sleeping</span>."
            </p>
            <p className="text-center font-semibold text-xl text-gray-900" data-id="element-287">
              Brenda, 72
            </p>
          </div>
        </div>
        <div className="mt-12 bg-gray-100 p-8 rounded-lg" data-id="element-288">
          <h3 className="text-2xl font-bold mb-4 text-gray-900" data-id="element-289">
            Why You Haven't Heard About This
          </h3>
          <p className="text-xl mb-4 text-gray-800" data-id="element-290">
            It's <span className="font-bold" data-id="element-291">not</span> because it doesn't work.
          </p>
          <p className="text-xl mb-4 text-gray-800" data-id="element-292">
            It's because the system makes money keeping us on{' '}
            <span className="font-bold" data-id="element-293">pills, gels, and surgeries</span>.
          </p>
          <p className="text-xl mb-4 text-gray-800" data-id="element-294">
            They <span className="font-bold" data-id="element-295">never talk</span> about the hidden
            circulation problem.
          </p>
          <p className="text-xl text-gray-800" data-id="element-296">
            And they definitely don't tell you about{' '}
            <span className="font-bold" data-id="element-297">simple solutions</span> that cut into
            their profits.
          </p>
        </div>
      </div>
    </section>;
};